import yup, {
    enumValidator,
    arrayValidator,
    conditionValueValidator,
    stringValidator,
    integerPositiveValidator,
} from '~/utils/validators.yup';
import { PROMPT_OPTIONS, GIVEN_TYPE_OPTIONS } from '~/config/constants';

export const promptDetailRule = {
    promptDetail: yup.object().shape({
        promptEffects: arrayValidator,
        promptDescription: stringValidator.max(300).nullable(),
        promptOption: enumValidator(PROMPT_OPTIONS),

        promptChoice1Effects: arrayValidator,
        promptChoice1Description: stringValidator.max(300).nullable(),
        promptChoice1RequirementOption: enumValidator(GIVEN_TYPE_OPTIONS),
        promptChoice1RequirementValue: integerPositiveValidator.required(),
        promptChoice1DvValue: conditionValueValidator('promptChoice1Effects'),
        promptChoice1DamageValue: conditionValueValidator('promptChoice1Effects'),

        promptChoice2Effects: arrayValidator,
        promptChoice2Description: stringValidator.max(300).nullable(),
        promptChoice2RequirementOption: enumValidator(GIVEN_TYPE_OPTIONS),
        promptChoice2RequirementValue: integerPositiveValidator.required(),
        promptChoice2DvValue: conditionValueValidator('promptChoice2Effects'),
        promptChoice2DamageValue: conditionValueValidator('promptChoice2Effects'),

        promptChoice3Effects: arrayValidator,
        promptChoice3Description: stringValidator.max(300).nullable(),
        promptChoice3RequirementOption: enumValidator(GIVEN_TYPE_OPTIONS),
        promptChoice3RequirementValue: integerPositiveValidator.required(),
        promptChoice3DvValue: conditionValueValidator('promptChoice3Effects'),
        promptChoice3DamageValue: conditionValueValidator('promptChoice3Effects'),

        promptChoice4Effects: arrayValidator,
        promptChoice4Description: stringValidator.max(300).nullable(),
        promptChoice4RequirementOption: enumValidator(GIVEN_TYPE_OPTIONS),
        promptChoice4RequirementValue: integerPositiveValidator.required(),
        promptChoice4DvValue: conditionValueValidator('promptChoice4Effects'),
        promptChoice4DamageValue: conditionValueValidator('promptChoice4Effects'),

        promptChoiceValueEffects: arrayValidator,
        promptChoiceBidEffects: arrayValidator,
    }),
};
